<template>
  <div class="screen-mode">
    <div class="screen-mode__wrapper">
      <label class="screen-mode__radio">
        <input type="radio"
               value="desktop"
               :checked="screen === 'desktop'"
               v-model="screen"
               @change="updateScreenMode">
        <div class="screen-mode__radio_dummy">
          <base-material-design-icon icon="desktop" class="screen-mode__radio-icon"></base-material-design-icon>
        </div>
      </label>
      <label class="screen-mode__radio">
        <input type="radio"
               value="mobile"
               :checked="screen === 'mobile'"
               v-model="screen"
               @change="updateScreenMode">
        <div class="screen-mode__radio_dummy">
          <base-material-design-icon icon="mobile" class="screen-mode__radio-icon"></base-material-design-icon>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
/**
   * Stylized radiobuttons group. Used in {@link ./ContentControlPanel}
   */
export default {
  name: 'ContentScreenModeSelect',
  props: {
    value: {
      type: String,
      default: 'desktop'
    }
  },
  data () {
    return {
      screen: ''
    }
  },
  watch: {
    value: {
      handler () {
        this.screen = this.value
      },
      immediate: true
    }
  },
  methods: {
    updateScreenMode () {
      this.$emit('screen', this.screen)
    }
  }
}
</script>

<style scoped lang="scss">

  .screen-mode {
    &__wrapper {
      width: fit-content;
      height: 40px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      border: 1px solid $rfx-border-color;
      border-radius: 4px;
      color: $rfx-dark-march;

    }

    &__radio {
      display: inline-flex;
      align-items: center;
      vertical-align: middle;
      user-select: none;
      border-color: $rfx-border-color;
      border-style: solid;

      &-icon {
        font-size: 20px;
        color: $rfx-dark-march;
      }

      &:first-child {
        border-width: 1px 0.5px 1px 1px;
        border-radius: 4px 0 0 4px;
      }

      &:last-child {
        border-width: 1px 1px 1px 0.5px;
        border-radius: 0 4px 4px 0;
      }

      input {
        display: none;

        &:checked {
          & + div {
            cursor: default;
            opacity: 1;
            background-color: $rfx-light-steel;
          }
        }
      }

      &_dummy {
        cursor: pointer;
        padding: 10px;
        display: flex;
        opacity: 0.5;
        background-color: #fff;
      }
    }
  }

</style>
